import api from './api';

export const cashFlowForecastService = {
  getForecasts: async (params = {}) => {
    try {
      const response = await api.get('/finance/cashflow/forecasts', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getForecast: async (forecastId) => {
    try {
      const response = await api.get(
        `/finance/cashflow/forecasts/${forecastId}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createForecast: async (data) => {
    try {
      const response = await api.post('/finance/cashflow/forecasts', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateForecast: async (forecastId, data) => {
    try {
      const response = await api.put(
        `/finance/cashflow/forecasts/${forecastId}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteForecast: async (forecastId) => {
    try {
      const response = await api.delete(
        `/finance/cashflow/forecasts/${forecastId}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  generateAIForecast: async (data) => {
    try {
      const response = await api.post('/finance/cashflow/generate-ai', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createScenario: async (forecastId, data) => {
    try {
      const response = await api.post('/finance/cashflow/scenarios', {
        ...data,
        forecastId,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getForecastAnalytics: async (forecastId) => {
    try {
      const response = await api.get('/finance/cashflow/analytics', {
        params: { forecastId },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
